import React from 'react';
import {
  AssignmentInd,
  Autorenew,
  Email,
  Gavel,
  Notifications,
  People, PointOfSale,
  ReceiptLong,
  SpaceDashboard,
  Timer
} from '@mui/icons-material';
import {SidebarItem} from '../../utils/Sidebar';
import DashboardLayout from '../../utils/DashboardLayout';
import Settings from '@mui/icons-material/Settings';
import {Outlet} from 'react-router-dom';

const systemMenu: SidebarItem[] = [
  {labelKey: 'dashboard.system.dashboard', to: '/system/dashboard', icon: SpaceDashboard},
  {labelKey: 'dashboard.system.trades', to: '/system/trades', icon: Autorenew},
  {labelKey: 'dashboard.system.buyorder', to: '/system/buy-order', icon: Gavel},
  {labelKey: 'dashboard.system.transactions', to: '/system/transactions', icon: ReceiptLong},
  {labelKey: 'dashboard.system.jobs', to: '/system/jobs', icon: Timer},
  {labelKey: 'dashboard.system.notifications', to: '/system/notifications', icon: Notifications},
  {labelKey: 'dashboard.system.settings', to: '/system/settings', icon: Settings},
  {labelKey: 'dashboard.system.payments', to: '/system/payments', icon: PointOfSale},
  {labelKey: 'dashboard.system.newsletter', to: '/system/newsletter', icon: Email},
  {labelKey: 'dashboard.system.users', to: '/system/users', icon: People},
  {labelKey: 'dashboard.system.roles-authorities', to: '/system/roles-authorities', icon: AssignmentInd},
];

const SystemLayout = () => {

  return (
      <DashboardLayout titleKey="dashboard.system.title" menuItems={systemMenu} isSystem={true}>
        <Outlet/>
      </DashboardLayout>
  );
};

export default SystemLayout;
